import Vue from 'vue'
import './plugins/bootstrap-vue'
import Router from 'vue-router';
import App from './App.vue'
import VueCookies from 'vue-cookies';
import VueMeta from 'vue-meta';
import VuePapaParse from 'vue-papa-parse'
import "@carbon/charts/styles.css";
import chartsVue from "@carbon/charts-vue";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueGtm from '@gtm-support/vue2-gtm';


Vue.use(chartsVue);


Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Router);
Vue.use(VueCookies);
Vue.use(VueMeta);
Vue.use(VuePapaParse)

import Landing from '@/pages/Landing';
import Auth from '@/pages/Auth';
import Dashboard from '@/pages/Dashboard';
import Trial from '@/pages/Trial';
import Trial2 from '@/pages/Trial2';
import Discord from '@/pages/Discord';
import Signup from '@/pages/Signup';
import Confirmation from '@/pages/Confirmation';
import Admin from '@/pages/Admin';
import Optionsdomination from '@/pages/Optionsdomination';
import Marketdomination from '@/pages/Marketdomination';
import Fullmarketdomination from '@/pages/Fullmarketdomination';
import Presignup from '@/pages/Presignup';
import PreDiscord from '@/pages/PreDiscord';
import Instagram from '@/pages/Instagram';
import TradeDetails from '@/pages/TradeDetails';
import TradeJournal from '@/pages/TradeJournal'
import UnsubscribeMail from '@/pages/UnsubscribeMail';
import Scanner from '@/pages/Scanner';
// import Course from '@/pages/Course';
import CourseAdmin from '@/pages/CourseAdmin';
import CourseTopic from '@/components/CourseTopic';
import TopicDetails from '@/components/TopicDetails';

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing,
      meta: {
        title: 'Market Moves - Landing'
      }
    },
    {
      path: '/tradedetails/:id',
      name: 'TradeDetails',
      component: TradeDetails,
      meta: {
        title: 'Market Moves - Trade Details'
      }
    },
    {
      path: '/course-topic',
      name: 'Course Topic',
      component: CourseTopic,
      props: true,
      meta: {
        title: 'Market Moves - Course Topic'
      }
    },
    {
      path: '/topic-details',
      name: 'Topic Details',
      component: TopicDetails,
      props: true,
      meta: {
        title: 'Market Moves - Topic Details'
      }
    },
    {
      path: '/course',
      name: 'Course',
      component: CourseAdmin,
      props: true,
      meta: {
        title: 'Market Moves - Course'
      }
    },
    {
      path: '/course-admin',
      name: 'Course Admin',
      component: CourseAdmin,
      props: true,
      meta: {
        title: 'Market Moves - Course Admin'
      }
    },
    {
      path: '/journal/:id',
      name: 'TradeJournal',
      component: TradeJournal,
      meta: {
        title: 'Market Moves - Trade Journal'
      }
    },
    {
      path: '/scanner',
      name: 'Scanner',
      component: Scanner,
      meta: {
        title: 'Market Moves - Scanner'
      }
    },
    {
      path: '/unsubscribe',
      name: 'UnsubscribeMail',
      component: UnsubscribeMail,
      meta: {
        title: 'Market Moves - Unsubscribe Mail'
      }
    },
    {
      path: '/Optionsdomination',
      name: 'Optionsdomination',
      component: Optionsdomination,
      meta: {
        title: 'Market Moves - Optionsdomination'
      }
    },
    {
      path: '/instagram',
      name: 'Instagram',
      component: Instagram,
      meta: {
        title: 'Market Moves - Instagram'
      }
    },
    {
      path: '/Marketdomination',
      name: 'Marketdomination',
      component: Marketdomination,
      meta: {
        title: 'Market Moves - Marketdomination'
      }
    },
    {
      path: '/Fullmarketdomination',
      name: 'Fullmarketdomination',
      component: Fullmarketdomination,
      meta: {
        title: 'Market Moves - Fullmarketdomination'
      }
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth

    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'Market Moves - Dashboard'
      }
    },
    {
      path: '/trial',
      name: 'Trial',
      component: Trial,
      meta: {
        title: 'Market Moves - Trial'
      }
    },
    {
      path: '/discord2',
      name: 'Trial',
      component: Trial2,
      meta: {
        title: 'Market Moves - Trial'
      }
    },
    {
      path: '/discord',
      name: 'Discord',
      component: Discord,
      meta: {
        title: 'Market Moves - Discord Trial'
      }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: {
        title: 'Market Moves - Signup'
      }
    },
    {
      path: '/presignup',
      name: 'Presignup',
      component: Presignup,
      meta: {
        title: 'Market Moves - Presignup'
      }
    },
    {
      path: '/prediscord',
      name: 'PreDiscord',
      component: PreDiscord,
      meta: {
        title: 'Market Moves - PreDiscord'
      }
    },
    {
      path: '/confirmation',
      name: 'Confirmation',
      component: Confirmation,
      meta: {
        title: 'Market Moves - Confirmation'
      }
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        title: 'Market Moves - Admin'
      }
    }
  ]
});


Vue.use(VueGtm, {
  id: 'GTM-PZDVZD5',
  queryParams: {
    // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
    gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
    gtm_preview: 'env-4',
    gtm_cookies_win: 'x'
  },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
});


new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
